module.exports = __webpack_public_path__ + "static/media/228-nauru.7c4e36ae.svg";